import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=c551a7a6&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c551a7a6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c551a7a6')) {
      api.createRecord('c551a7a6', component.options)
    } else {
      api.reload('c551a7a6', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=c551a7a6&scoped=true&", function () {
      api.rerender('c551a7a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2o3vMBJpN8eFX/JS/comp/SearchFilterTokens.vue"
export default component.exports